import { useCallback, useEffect, useState } from 'react';
import { usePersonnesPort } from '@taki/ui';
import type { PersonneVue } from '@taki/ui';

/**
 * LES PERSONNES DE L'ORG, par l'annuaire du shell : moi, l'equipe, et un nom
 * pour un id. Sans annuaire, tout est vide et aucun nom ne s'affiche. Partage
 * par le Dossier de l'animal et par la fenetre « Consulter maintenant ».
 */
export function useAnnuaire(): { moi: string; personnes: readonly PersonneVue[]; nomDePersonne: (personId: unknown) => string } {
  const port = usePersonnesPort();
  const [personnes, setPersonnes] = useState<readonly PersonneVue[]>([]);
  useEffect(() => {
    if (port === null) return;
    let vivant = true;
    void port.lister().then(
      (liste) => vivant && setPersonnes(liste),
      () => vivant && setPersonnes([]),
    );
    return () => {
      vivant = false;
    };
  }, [port]);
  const nomDePersonne = useCallback(
    (personId: unknown): string => {
      const personne = personnes.find((p) => p.personId === personId);
      return personne === undefined ? '' : personne.displayName || personne.email;
    },
    [personnes],
  );
  return { moi: port?.moi?.personId ?? '', personnes, nomDePersonne };
}
